import * as z from "zod";

const config = z.record(z.string(), z.unknown());
/** A coverage_settings row id. */
const versionId = z.string().regex(/^\d+$/);
const cursor = z.object({ id: versionId });

export const getCoverageBuilderHistory = {
  name: "getCoverageBuilderHistory" as const,
  input: z.object({ after: cursor.optional() }).nullable(),
  output: z.object({
    currentVersionId: versionId.optional(),
    nextCursor: cursor.optional(),
    versions: z.array(
      z.object({
        id: versionId,
        name: z.string().optional(),
        createdAt: z.date(),
        actor: z.string().optional(),
        source: z.string(),
        restoredFrom: versionId.optional(),
      }),
    ),
  }),
};

export const getCoverageBuilderVersion = {
  name: "getCoverageBuilderVersion" as const,
  input: z.object({ id: versionId }),
  output: z.object({ config }),
};

export const saveCoverageBuilder = {
  name: "saveCoverageBuilder" as const,
  input: z.object({
    config: z.unknown(),
    expectedConfig: config.nullable(),
    name: z.string().trim().min(1).max(200).optional(),
    restoredFrom: versionId.optional(),
  }),
  output: z.object({}),
};
